import { MdxPage } from '@features/mdx/MdxPage';
import { AppLanguageCodes } from '@project-types/AppLanguageCodes';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[AppLanguageCodes.CZ]: '93d79456-bc28-4460-8d07-a58cb299175e',
	[AppLanguageCodes.SK]: '93d79456-bc28-4460-8d07-a58cb299175e',
	[AppLanguageCodes.DE]: '93d79456-bc28-4460-8d07-a58cb299175e',
}


export const History = () => {

	return (
		<MdxPage className='history-page' articleIds={articleIds}>
		</MdxPage>
	);
};